
import { useEffect, useState } from 'react';
import { supabase } from "@/integrations/supabase/client";
import { motion } from "framer-motion";
import { Badge } from "@/components/ui/badge";

interface LGAHeaderProps {
  lgaName: string;
  stateName: string;
}

const LGAHeader = ({ lgaName, stateName }: LGAHeaderProps) => {
  const [memberCount, setMemberCount] = useState<number | null>(null);
  const [loading, setLoading] = useState(true);
  
  // Fetch member count for this LGA
  useEffect(() => {
    const fetchMemberCount = async () => {
      try {
        const { count, error } = await supabase
          .from('community_members')
          .select('*', { count: 'exact', head: true })
          .eq('state', stateName)
          .eq('local_government', lgaName)
          .eq('approved', true);
          
        if (error) throw error;
        
        setMemberCount(count || 0);
      } catch (error) {
        console.error('Error fetching member count:', error);
      } finally {
        setLoading(false);
      }
    };
    
    fetchMemberCount();
  }, [lgaName, stateName]);

  return (
    <motion.div 
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      className="flex items-center justify-between mb-3"
    >
      <div>
        <h3 className="font-semibold text-lg flex items-center">
          {lgaName}
          <Badge variant="outline" className="ml-2 font-normal">
            {stateName}
          </Badge>
        </h3>
        <p className="text-sm text-gray-500">
          {loading ? 'Loading members...' : `${memberCount} approved ${memberCount === 1 ? 'member' : 'members'}`}
        </p>
      </div>
    </motion.div>
  );
};

export default LGAHeader;
